/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const exclamation_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M11.997 15.118V3.25m-.646 16.765h1.31m.089 0c0 .438-.31.747-.753.747a.718.718 0 0 1-.747-.747c0-.442.31-.753.747-.753.443 0 .753.31.753.753Z"
    />
  </svg>
)
export default exclamation_medium
